export default function Footer() {
    return (
        <footer className="text-white mx-auto">
            <p>Auyesbay Didar, 2023 :)</p>
        </footer>
    )
}